import {useSelector} from "react-redux";
import {Typography} from "@bolteu/clay-react";

import {useI18n} from "i18n/i18n";
import {brandSelector} from "store/selectors/brandSelector";
import {SocialMediaLinks, SocialMediaOptions} from "webform/components/Footer/socialMediaLinks";

import facebookLogo from "webform/assets/facebook.svg";
import instagramLogo from "webform/assets/instagram.svg";
import xLogo from "webform/assets/x.svg";

import * as Styled from "./footer.styled";

export const Footer = () => {
    const i18n = useI18n();
    const brand = useSelector(brandSelector);
    const handleClick = (selection: SocialMediaOptions) => {
        if (brand) {
            window.open(SocialMediaLinks[brand][selection], "_blank");
        }
    };
    return (
        <Styled.Background>
            <Styled.Footer>
                <Styled.SloganWrapper>
                    <Typography className="bolt-font-body-m-regular text-secondary">
                        {i18n("webform.footer.made_with_love_emoji_in_estonia", {
                            values: {heart_emoji: "💚"},
                        })}
                    </Typography>
                </Styled.SloganWrapper>
                {!!brand && (
                    <Styled.SocialMediaButtonContainer>
                        <Styled.SocialMediaButton onClick={() => handleClick(SocialMediaOptions.FACEBOOK)}>
                            <img src={facebookLogo} alt="Facebook link" />
                        </Styled.SocialMediaButton>
                        <Styled.SocialMediaButton onClick={() => handleClick(SocialMediaOptions.INSTAGRAM)}>
                            <img src={instagramLogo} alt="Instagram link" />
                        </Styled.SocialMediaButton>
                        <Styled.SocialMediaButton onClick={() => handleClick(SocialMediaOptions.X)}>
                            <img src={xLogo} alt="X link" />
                        </Styled.SocialMediaButton>
                    </Styled.SocialMediaButtonContainer>
                )}
            </Styled.Footer>
        </Styled.Background>
    );
};
